<template>
   <div class="h-[100vh] w-[100vw] flex justify-center items-center">
      <loading-section></loading-section>
   </div>
</template>
<script>
export default {
   data() {
      return {
         hash: null
      };
   },
   watch: {

   },
   methods: {},
   async created () {
      this.hash = this.$route.query.hash ?? null;

      if(!this.hash )
         this.$router.replace("/")

      let response = await this.$store.dispatch("confirmUser",{
         type: "confirmed_email",
         hash: this.hash,
      });

      console.log("response ",response );

      if(response.response.result == "found"){
         this.$store.commit("main_loader", true);
         this.$store.commit("main_loader", true);
         await new Promise(resolve => setTimeout(resolve, 1000));
         this.$router.replace("/login")
      }
   },
};
</script>

<style lang="scss" scoped>
/*  */
</style>